@if (isSpezialGrundstueckOnlyAvailableInNESKOAB) {
  <cap-link
    [enableNavigation]="hasPermissionForSpezialGrundstueck && canNavigate"
    [queryParams]="{ gemeindeId: item.gemeinde?.id?.id, nummer: item.nummer, nummer2: item.nummer2, nummer3: item.nummer3 }"
    [target]="navTargets.NAV_NESKOAB_GRUNDSTUECK"
    [tooltipParams]="{ nummer: item | NeskoabGrundstuecknummerPipe }">
    <ng-template [ngTemplateOutlet]="value"></ng-template>
  </cap-link>
}

@if (!isSpezialGrundstueckOnlyAvailableInNESKOAB) {
  <cap-link
    [queryParams]="{ egrid: item.egrid }"
    [target]="navTargets.NAV_GRUNDSTUECK_NESKOAB"
    [tooltipParams]="{ nummer: item | NeskoabGrundstuecknummerPipe }">
    <ng-template [ngTemplateOutlet]="value"></ng-template>
  </cap-link>
}

<ng-template #value>
  {{ item | NeskoabGrundstuecknummerPipe: language }}
</ng-template>
